import NProgress from 'nprogress'
import tarteaucitron from '../../../vendor/assets/javascripts/tarteaucitron/tarteaucitron'

$(document).ready(function() {

  function calculPourcentageHauteur(block) {
    var fullTableWidth = $('.o-tableCompare').width();
    var normalTableWidth = block.width();
    var scrollLeft= block.scrollLeft();
    var positionDiffTable = fullTableWidth - normalTableWidth;
    var ratioWidth = scrollLeft/ positionDiffTable;
    var pourcentageWidth = Math.floor(ratioWidth * 100);

    return pourcentageWidth;
  }

  $('#di_comparatifFull .o-pageContainer .o-content .o-content__container .o-tableContainer .o-scrollContainer').each(function(){
    var block = $(this);

    //NPROGRESS BAR
    NProgress.configure({parent : '.o-scrollBarContainer' });
    NProgress.set(0.1);

    block.on('scroll', function(){
      var w = calculPourcentageHauteur(block);

      if (w==0) {
        w = 10;
      } else if (w == 100) {
        w = 99;
      }

      NProgress.set(w / 100);

      //AJOUTER IF NOMBRE DE TH <= 3 DISPLAY NONE

    })
  })

  var block, toggleButton, search;

  //icone filtrer dans la page actualité du blog
  $('.o-blog-content').each(function() {
    block = $(this);
    toggleButton = block.find('.o-filter');
    search = block.find('.o-actualites__search');

    toggleButton.on('click', function() {
      $(this).toggleClass('opened');
      search.slideToggle(400);
    });

    $(window).on('load resize', function() {
      if ($(window).width() <= 767) {
        search.hide();
      } else {
        search.show();
      }
    });
  });

  //changement de texte dans le button de la newsletter
  $(window).on('load resize', function() {
    var button = $('.o-newsletter').find('button');

    if ($(window).width() <= 767) {
      button.text("s'inscrire");
    } else {
      button.text('me tenir informé');
    }
  });

  //changement de texte dans le button de la newsletter
  $('.o-packages__item.choose').each(function(){
    var button = $(this).find('.o-classicButton');

    button.text('ma formule');
  })

  //slick page comparatifEmpty

  $('.o-sliderContainer').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false
  });

  //changement de taille graphique dans la page analyse Patrimoine
  $('.o-graph').each(function() {
    var container = $(this),
        arrow = container.find('.o-graph__arrow'),
        full = container.find('.o-graph__full'),
        empty = container.find('.o-graph__empty');

    const updateGraph = () => {
      var fullWidth = full.width();

      if (fullWidth > 0) {
        empty.width(container.width() - fullWidth);
        arrow.css('left', fullWidth);
      }

      arrowPosition = parseInt(arrow.css("left"));
      if (arrowPosition >= container.width() || arrowPosition <= 0) {
        arrow.css("display", "none");
      }
    }

    // Use IntersectionObserver to detect when element becomes visible
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            updateGraph();
          }
        });
      });
      observer.observe(container[0]);
    } else {
      // Fallback for older browsers
      updateGraph();
    }
  });

  // button filter page Analyse

  $('.o-analyses__content__menuHidden').each(function() {
    var block = $(this),
        toggleButton = block.find('.o-analyses__content__menuHidden__item.filter'),
        menuToHide = $('.o-analyses__content__menu'),
        link = menuToHide.find('.o-analyses__content__menu__item'),
        checkboxHidden = $('o-checkbox__hidden').find('p'),
        checkboxToHide = $('.o-checkbox__container'),
        textButton = toggleButton.find('p');

    toggleButton.on('click', function() {
      $(this).find('p').toggleClass('opened');
      menuToHide.slideToggle(400);
    })

    checkboxHidden.on('click', function() {
      $(this).find('p').toggleClass('opened');
      checkboxToHide.slideToggle(400);
    })

    $(window).on('load resize', function() {
      if ($(window).width() <= 767) {
        checkboxToHide.hide();
        link.on('click', function(){
        menuToHide.slideToggle(400);
        textButton.toggleClass('opened');
      })

      } else {
        checkboxToHide.show();
      }
    });
  })


  // button filter page fondsTable

  $('.o-checkbox__hidden').each(function() {
    var block = $(this),
        checkboxHidden = block.find('p');
        checkboxToHide = $('.o-checkbox__container')

    checkboxHidden.on('click', function() {
      $(this).addClass('opened');
      checkboxToHide.slideToggle(400);
    })

    $(window).on('load resize', function() {
      if ($(window).width() <= 1023) {
        checkboxToHide.hide();
      } else {
        checkboxToHide.show();
      }
    });
  })

  // recupere le text du menu pour l'injecter dans la div namecategory

  $('.o-analyses__content__menu__item.o-js-tabs__link').each(function() {
    var block = $(this),
        nameCategory = $('.o-analyses__content__menuHidden__item.name').find('p');

    block.on('click', function(){
      var content = block.text();
      nameCategory.text(content);
    })
  })

    // page fondsTable click sur o-checkbox list deroulante

  $('.o-checkbox').each(function() {
    var block = $(this),
        // listName = block.find('p'),
        blockToShow = block.find('.o-checkbox__list');

    block.on('click', function(){
      if ($(window).width() <= 1023) {
        block.toggleClass('closed');
        blockToShow.slideToggle(400);;
      }
    })
  });

  // page fondsTable click sur o-checkbox list deroulante

  $('#di_fondsTable .o-buttonMenu__container, #di_annuairePro .o-buttonMenu__container').each(function() {
    var block = $(this),
        button = block.find('.o-buttonMenu'),
        blockToShow = $('.o-checkbox__container');

    block.on('click', function(){
      if(button.hasClass('close')){
        button.removeClass('close');
        blockToShow.removeClass('open');
        button.text('Affiner la recherche');
      } else {
        button.addClass('close');
        button.text('Réduire la recherche');
        blockToShow.addClass('open');
      }
    })
  });

  // page presentationMethologie block 4block open

  $('.o-4blocks').each(function() {
    var block = $(this),
        blockWidth = $(this).width();
        blockHeight = $(this).height();
        link = block.find('.o-4blocks__item a'),
        button = $('.o-4blocks__item__hidden a'),
        content = $('.o-4block__item__hidden__content'),

    $(window).on('load resize', function() {
      if ($(window).width() >= 767) {

        link.on('click', function(e){
          if ($(this).attr('href') == '#') {
            e.preventDefault();
            $(this).parent().parent().find('.o-4blocks__item__hidden__content').removeClass('hide');
            $(this).parent().parent().find('.o-4blocks__item__hidden').addClass('opened').height(blockHeight - 28).width(blockWidth);
            $(this).parent().parent().find('.o-4blocks__item__hidden__content').addClass('visible');
          }
        })

        button.on('click', function(event){
          event.preventDefault();
          $(this).parent().parent().width(0);
          $(this).parent().parent().height(0);
          $(this).parent().parent().removeClass('opened');
          $(this).parent().removeClass('visible');
          $(this).parent().addClass('hide');
        })

      } else {

        link.on('click', function(e){
          if ($(this).attr('href') == '#') {
            e.preventDefault();
            $(this).parent().parent().find('.o-4blocks__item__hidden').slideToggle();
          }
        })

        button.on('click', function(event){
          event.preventDefault();
          $(this).parent().parent().slideToggle();
        })
      }
    });
  })

  // custom tooltipster page analysesCommun

  $('.tooltip').tooltipster({
    theme: ['tooltipster-noir', 'tooltipster-noir-customized'],
    animation: 'fade',
    delay: 200,
    zIndex: 50,
    contentAsHTML: true,
    side: 'right',
    trigger: 'custom',
    triggerOpen: {
        click: true,
        tap: true,
        mouseenter: true
    },
    triggerClose: {
        click: true,
        tap: true,
        mouseleave: true
    }
  });

  tarteaucitron.init({
      "hashtag": "#tarteaucitron", /* Ouverture automatique du panel avec le hashtag */
      "highPrivacy": false, /* désactiver le consentement implicite (en naviguant) ? */
      "orientation": "bottom", /* le bandeau doit être en haut (top) ou en bas (bottom) ? */
      "adblocker": true, /* Afficher un message si un adblocker est détecté */
      "showAlertSmall": false, /* afficher le petit bandeau en bas à droite ? */
      "cookieslist": true, /* Afficher la liste des cookies installés ? */
      "removeCredit": false, /* supprimer le lien vers la source ? */
      "handleBrowserDNTRequest": false, /* Deny everything if DNT is on */
      "privacyUrl": "/pages/mentions-legales",
      //"cookieDomain": ".example.com" /* Nom de domaine sur lequel sera posé le cookie pour les sous-domaines */
  });
  tarteaucitron.reloadThePage = true;

  (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
});
